module.exports = __webpack_public_path__ + "img/icn_brand19.2bee6040.svg";